const tour = {
  actions: {
    startTour: "Iniciar recorrido",
    takeAgain: "Repetir recorrido",
  },
  ariaLabel: "Recorridos guiados",
  coachInterfaceIntro: {
    title: "Conoce Coach AI",
    description: "Una introducción rápida a lo esencial de Coach AI.",
    smokeDescription:
      "Esta breve animación de bienvenida está lista para el recorrido completo de Coach AI.",
    desktop: {
      welcome: {
        title: "Te damos la bienvenida a Coach AI",
        description:
          "Recorre rápidamente la interfaz antes de iniciar tu próxima conversación sobre seguridad.",
      },
      scope: {
        title: "Define el alcance",
        description:
          "Elige el cliente y el grupo de vehículos que Coach AI debe usar para tus preguntas. Esto determina los datos disponibles para Coach durante la conversación, por ejemplo, los informes y las puntuaciones de rendimiento por exceso de velocidad.",
      },
      sidebar: {
        title: "Navega desde la barra lateral",
        description:
          "Inicia un chat, revisa el Historial, reutiliza las Indicaciones guardadas, explora las Sugerencias de Coach, ajusta la Configuración o vuelve aquí para los recorridos.",
      },
      history: {
        title: "Vuelve a los chats recientes",
        description:
          "Revisa conversaciones anteriores con Coach AI y exporta las respuestas.",
      },
      savedPrompts: {
        title: "Reutiliza preguntas útiles",
        description:
          "Las indicaciones guardadas te permiten tener a mano tus preguntas favoritas para reutilizarlas. Haz doble clic en una indicación para enviarla.",
      },
      coachSuggestions: {
        title: "Usa las sugerencias de Coach",
        description:
          "Explora preguntas de seguridad listas para usar en las sugerencias de Coach. Selecciona una para enviarla a Coach AI.",
      },
      settings: {
        title: "Elige tus idiomas",
        description:
          "Configura el idioma de la aplicación y el idioma que Coach AI usa para responder.",
      },
      composer: {
        title: "Inicia la conversación",
        description:
          "Haz una pregunta sobre seguridad con tus propias palabras o elige una sugerencia para comenzar.",
      },
      closing: {
        title: "Ya puedes explorar",
        description:
          "Vuelve a Recorridos guiados cuando quieras repetir esta introducción o descubrir un recorrido nuevo.",
      },
    },
    mobile: {
      welcome: {
        title: "Te damos la bienvenida a Coach AI",
        description:
          "Recorre rápidamente la interfaz antes de iniciar tu próxima conversación sobre seguridad.",
      },
      scope: {
        title: "Define el alcance",
        description:
          "Elige el cliente y el grupo de vehículos que Coach AI debe usar para tus preguntas.",
      },
      sidebar: {
        title: "Abre el menú",
        description:
          "Usa este botón para abrir los chats recientes, las indicaciones guardadas, las sugerencias de Coach, la configuración y los recorridos guiados.",
      },
      history: {
        title: "Vuelve a los chats recientes",
        description:
          "Revisa conversaciones anteriores con Coach AI y exporta las respuestas.",
      },
      savedPrompts: {
        title: "Reutiliza preguntas útiles",
        description:
          "Las indicaciones guardadas te permiten tener a mano tus preguntas favoritas para reutilizarlas.",
      },
      coachSuggestions: {
        title: "Usa las sugerencias de Coach",
        description:
          "Explora preguntas de seguridad listas para usar en las sugerencias de Coach. Selecciona una para enviarla a Coach AI.",
      },
      settings: {
        title: "Elige tus idiomas",
        description:
          "Configura el idioma de la aplicación y el idioma que Coach AI usa para responder.",
      },
      composer: {
        title: "Inicia la conversación",
        description:
          "Haz una pregunta sobre seguridad con tus propias palabras o elige una sugerencia para comenzar.",
      },
      closing: {
        title: "Ya puedes explorar",
        description:
          "Vuelve a Recorridos guiados cuando quieras repetir esta introducción o descubrir un recorrido nuevo.",
      },
    },
  },
  errors: {
    loadFailed: "No se pudieron cargar los recorridos guiados.",
    completionFailed: "No se pudo guardar la finalización del recorrido.",
  },
  loading: "Cargando recorridos guiados...",
  popover: {
    back: "Atrás",
    close: "Cerrar recorrido",
    done: "Listo",
    next: "Siguiente",
    progress: "Paso {{current}} de {{total}}",
  },
  status: {
    completed: "Completado",
    notStarted: "Sin comenzar",
  },
} as const;

export default tour;
